import React from "react";

export const RWSContext = React.createContext();
